import { tempActions } from "../../Store/TempStore/reducer";
import { TempStore } from "../../Store/TempStore/types";

export const handleTempStates = (stateKey: string, state: TempStore, fieldName: string, value: any) => {
    if(value === "" && Object.keys(state[stateKey]).length === 1){
      return {actionType: tempActions.removeFromTemp, key: stateKey};
    } else if (value === "" && Object.keys(state[stateKey]).length > 1){
      delete state[stateKey][fieldName];
      return {actionType: tempActions.updateInTemp, key: stateKey, values: state};
    } else {
      return {actionType: tempActions.saveInTemp, key: { ...state, [stateKey]: {...state[stateKey], [fieldName]: value}}};
    }
}